import { User } from "firebase/auth";
import { atom } from "recoil";

export const firebaseUserState = atom({
    key: 'firebaseUserState',
    default: null as User | null,
    dangerouslyAllowMutability: true
})